export namespace Keys {
  export namespace Plugin {
    export const Name = 'keys';
  }

  export interface API {
    isPressed(key: string): boolean;
    getPressedKeys(): string[];
    setOverrides(overrides: Keys.Override[]): void;
    removeOverrides(overrides: Keys.Override[]): void;
  }

  export interface PublicAPI {
    [Keys.Plugin.Name]: Keys.API;
  }

  export enum Events {
    Keydown = 'Keydown',
    Keyup = 'Keyup',
  }

  export interface Override {
    callback: Function;
    key: string;
    trigger?: Keys.Events;
  }
}
